// Kenworthy Orthodontics (Dr. Christian R Kenworthy, Missoula MT) - single
// online-bookable office. Backend: bondLocations.ts KENWORTHY_MISSOULA
// (brandId "kenworthy", catalog be2df3fc = 5217_Bond_Kenworthy_Merge, Edge loc 2,
// procedure 94, link ltfpgb). Native booking via ortho2-newpatient backend
// (WCF intake disabled). English-only.
//
// Thompson Falls (Edge loc 8) is deliberately EXCLUDED: it exists in the catalog
// but /search/next-available returns 204 and a 26-week sweep found zero slots, so
// it has no online new-patient availability. Add it here once Bond opens it up.
import type { BrandConfig } from "./types";

export const kenworthy: BrandConfig = {
  slug: "kenworthy",
  brandId: "kenworthy",
  brandName: "Kenworthy Orthodontics",
  logo: "https://kenworthyorthodontics.com/wp-content/uploads/2024/05/kenworthy-logo-whiteback.png",
  phone: "(406) 721-2796",
  phoneHref: "tel:+14067212796",
  theme: { primary: "#48B4E7", primaryDark: "#2F7596" }, // scoured 2026-08-06 kenworthyorthodontics.com (sky blue; #5BBE64 green is the secondary accent)
  locales: ["en"],
  locations: {
    KENWORTHY_MISSOULA: {
      id: "KENWORTHY_MISSOULA",
      name: "Missoula",
      addressLines: ["3020 S Reserve St, Ste E", "Missoula, MT 59801"],
      mapsUrl: "https://maps.google.com/?q=3020+S+Reserve+St+Ste+E+Missoula+MT+59801",
      timezone: "America/Denver",
    },
  },
  locationAliases: { MISSOULA: "KENWORTHY_MISSOULA", KENWORTHY: "KENWORTHY_MISSOULA" },
};
